// extracted by mini-css-extract-plugin
export const html = "projectTemplate-module--html--1WdlO";
export const btn_container = "projectTemplate-module--btn_container--21_ne";